<script setup>
import { ref } from "vue";
import BreezeAuthenticatedLayout from '@/Layouts/Authenticated.vue';
import CardBox from "@/Components/CardBox.vue";
import BreezeButton from '@/Components/Button.vue';
import BreezeGuestLayout from '@/Layouts/Guest.vue';
import BreezeInput from '@/Components/Input.vue';
import BreezeLabel from '@/Components/Label.vue';
import BreezeValidationErrors from '@/Components/ValidationErrors.vue';
import { Inertia } from '@inertiajs/inertia';
import { Head, Link, useForm } from '@inertiajs/inertia-vue3';
import BaseButton from "@/Components/BaseButton.vue";
import CardBoxModal from "@/Components/CardBoxModal.vue";
const props = defineProps({
    origin_type: String,
    object_target: Array,
    action: {
            type: String,
            default: 'create'
        },
    object: Object,
});

const rutaPrefijo = ref('file')
const src_type = props.origin_type;
const actionText = ref('Actualizar');
if (props.action=='create') actionText.value = 'Registrar';
//console.log(props.origin_type);

const form = useForm({
    id: props.object ? props.object.id : 0,

    //label: '',
    file: null,
    filename: '',
    oldfilepath: props.object ? props.object.filepath : '',
    oldfilename: props.object ? props.object.filename : '',
    originName: '',
    src_object_type: src_type,
    old_src_object_id: props.object ? props.object.src_object_id : 0,
    src_object_id: props.object ? props.object.src_object_id : 0,
    name: props.object ? props.object.name : '',
    description: props.object ? props.object.description : '',
    position: props.object ? props.object.position : '',
    //password: '',
    //password_confirmation: '',
    terms: false,
    type: ''
});

const deleteable = ref(true)
const rowID = ref(0);
const isModalDangerActive = ref(false)
const rowAction = ref('');
const initModal = (id, action) => {
      //isErrorForm.value = false
      rowAction.value = action
      rowID.value = id;
      isModalDangerActive.value = true
}
const isConfirm = () => {
    
    const ruta = rutaPrefijo.value + '-' + rowAction.value
    
    if (rowAction.value == 'eliminar') {
        Inertia.post(route(ruta, {
            'id' : rowID.value,
            }
        ))
        //alert(rutaPrefijo.value +'Hola '+rowID.value+'modal es '+rowAction.value)
    }
    
    cleanVal()
    
}
const isCancel = () => {
    cleanVal()
}
const cleanVal = () => {
    rowID.value = 0;
    rowAction.value = ''


}

const submit = () => {

    /* form.post(route('file-registrar'), {
        //onFinish: () => form.reset('password', 'password_confirmation'),
    }); */

    if (props.action=='create') {
        form.post(route(rutaPrefijo.value+'-registrar'), {
            //onSuccess: () => form.reset('apellidos', 'nombres', 'email', 'telefono', 'celular', 'obs_aprendizaje'),
        });
    } else {
        form.put(route(rutaPrefijo.value+'-actualizar'), {
            //onFinish: () => form.reset('apellidos, nombres, email, telefono, celular, obs_aprendizaje'),
        });
    }
};

const isImagen = ref(false)
const imgMiniatura = ref('')
const handleFileUp = (event) => {
    //fileSubida.value = this.$refs.fileSubida.files[0];
    //fileSubida.value = event.target.files[0];
    //console.log(event.target.files[0]);

    if(form.originName.includes('.jpg') || form.originName.includes('.png')) {
        isImagen.value = true
    } else {
        isImagen.value = false
    }

    let file = event.target.files[0];
    //this.product.imagen=file
    form.file = file
    //console.log(file)
    console.log(form.file)
    fileUp(file)

}
const fileUp = (file) => {
    let reader = new FileReader()
    reader.onload = (e) => {
        imgMiniatura.value = e.target.result
    }
    reader.readAsDataURL(file)
}
</script>

<template>
    <Head :title="actionText + ' documento'" />

    <BreezeAuthenticatedLayout>
        <template #header>
            <h2 class="font-semibold text-xl text-gray-800 leading-tight">
                <template v-if="origin_type == 'file_guideforcourse'">
                    {{actionText}} Guías de estudio <!-- In basebutton: @click="route('dashboard')"-->
                </template>
                <template v-else-if="origin_type == 'file_forlevel'">
                    {{actionText}} Documento por nivel educativo
                </template>
                <template v-else-if="origin_type == 'file_resourceforcourse'">
                    {{actionText}} Recursos de estudio
                </template>
                <template v-else>
                    {{actionText}} Documento
                </template>
                
                <CardBoxModal
                    v-model="isModalDangerActive"
                    title="Por favor confirmar"
                    button="danger"
                    has-cancel
                    @confirm="isConfirm" @cancel="isCancel"
                >   
                    <p>Está seguro de <b v-text="rowAction"></b></p>
                    <p>Este registro?</p>
                </CardBoxModal>
                <!--<Link :href="route('fileforlevel-create')">
                    <BaseButton
                        color="info"
                        :icon="mdiPlusCircle"
                        small
                        label=" Nuevo"
                        class="ml-2 inline-flex cursor-pointer justify-center items-center whitespace-nowrap focus:outline-none transition-colors focus:ring duration-150 border rounded border-blue-600 dark:border-blue-500 ring-blue-300 dark:ring-blue-700 bg-blue-600 dark:bg-blue-500 text-white hover:bg-blue-700 hover:border-blue-700 hover:dark:bg-blue-600 hover:dark:border-blue-600 p-1 float-right"
                    />
                </Link>-->
                <!--
                <a href="/public/studentcreate" target="_blank">
                    <BaseButton
                        color="info"
                        :icon="mdiPlusCircle"
                        small
                        label=" Registro público"
                        class="inline-flex cursor-pointer justify-center items-center whitespace-nowrap focus:outline-none transition-colors focus:ring duration-150 border rounded border-blue-600 dark:border-blue-500 ring-blue-300 dark:ring-blue-700 bg-blue-600 dark:bg-blue-500 text-white hover:bg-blue-700 hover:border-blue-700 hover:dark:bg-blue-600 hover:dark:border-blue-600 p-1 float-right"
                    />
                </a>-->
            </h2>   
        </template>
        <div class="py-12">
            <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
                <div class="bg-white overflow-hidden shadow-sm sm:rounded-lg">
                    <div class="p-6 bg-white border-b border-gray-200">
                        <BreezeValidationErrors class="mb-4" />

                        <template v-if="action=='create'">
                            <form @submit.prevent="submit" enctype="multipart/form-data"><!-- enctype="multipart/form-data"-->
                                <div class="mt-4">
                                    <BreezeLabel for="name" value="Nombre" :required="true" />
                                    <BreezeInput id="name" type="text" class="mt-1 block w-full" v-model="form.name" required autofocus autocomplete="Nombre" />
                                </div>
                                <div class="mt-4">
                                    <BreezeLabel for="description" value="Descripción" />
                                    <!--<textarea id="description" class="mt-1 block w-full mt-1 block w-full border-gray-300 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 rounded-md shadow-sm" v-model="form.description" autocomplete="description" />-->
                                    <BreezeInput id="description" type="text" class="mt-1 block w-full" v-model="form.description" autocomplete="descripción" />
                                </div>
                                <div class="mt-4">
                                    <template v-if="origin_type == 'file_guideforcourse'">
                                        <BreezeLabel for="src_object_id" value="Curso relacionado a la guía de estudio" :required="true" />
                                    </template>
                                    <template v-else-if="origin_type == 'file_forlevel'">
                                        <BreezeLabel for="src_object_id" value="Nivel escolar al que se mostrará este archivo" :required="true" />
                                    </template>
                                    
                                    <select id="src_object_id" class="mt-1 block w-full border-gray-300 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 rounded-md shadow-sm" v-model="form.src_object_id" required >
                                        <option value="0" selected="selected">Todos</option>
                                        <option v-for="field in object_target" :value="field.id">{{ field.label_object}}</option>
                                    </select>
                                </div>
                                <div class="mt-4">
                                    <BreezeLabel for="file" value="Subir archivo" :required="true" /><!--v-model="form.file"-->
                                    <BreezeInput id="file" ref="file" type="file" class="mt-1 block w-full" v-model="form.originName" required autocomplete="file" @change="handleFileUp" accept=".PDF, .PNG, .JPG" /><!--.XLSX, -->
                                </div>
                                <div class="mt-4">
                                    <BreezeLabel for="position" value="Posición" :required="true" /><!--v-model="form.position"-->
                                    <BreezeInput id="position" ref="position" type="number" class="mt-1 block w-full" v-model="form.position" required autocomplete="position" /><!--.XLSX, -->
                                </div>
                                
                                <!--<span>{{form.file}}</span>-->
                                <br>
                                <div v-if="isImagen">
                                    <img :src="imgMiniatura" alt="img file" class="object-cover h-48">
                                </div>
                                <!--
                                <div class="mt-4">
                                    <BreezeLabel for="password" value="Password" />
                                    <BreezeInput id="password" type="password" class="mt-1 block w-full" v-model="form.password" required autocomplete="new-password" />
                                </div>

                                <div class="mt-4">
                                    <BreezeLabel for="password_confirmation" value="Confirm Password" />
                                    <BreezeInput id="password_confirmation" type="password" class="mt-1 block w-full" v-model="form.password_confirmation" required autocomplete="new-password" />
                                </div>-->

                                <div class="flex items-center justify-end mt-4">
                                    <!-- <Link :href="route('file-listado', origin_type)" class="underline text-sm text-gray-600 hover:text-gray-900">
                                        Volver al listado
                                    </Link> -->
                                    <Link :href="route('file-listado', origin_type)" class="btn btn-outline-gray"><!-- update 230412 : underline text-sm text-gray-600 hover:text-gray-900 -->
                                        Volver al listado
                                    </Link>

                                    <BreezeButton class="ml-4" :class="{ 'opacity-25': form.processing }" :disabled="form.processing">
                                        Registrar
                                    </BreezeButton>
                                </div>
                            </form>
                        </template>
                        <template v-else>
                            <form @submit.prevent="submit" enctype="multipart/form-data"><!-- enctype="multipart/form-data"-->
                                <div class="mt-4">
                                    <BreezeLabel for="name" value="Nombre" :required="true" />
                                    <BreezeInput id="name" type="text" class="mt-1 block w-full" v-model="form.name" required autofocus autocomplete="Nombre" />
                                </div>
                                <div class="mt-4">
                                    <BreezeLabel for="description" value="Descripción" />
                                    <!--<textarea id="description" class="mt-1 block w-full mt-1 block w-full border-gray-300 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 rounded-md shadow-sm" v-model="form.description" autocomplete="description" />-->
                                    <BreezeInput id="description" type="text" class="mt-1 block w-full" v-model="form.description" autocomplete="descripción" />
                                </div>
                                <div class="mt-4">
                                    <template v-if="origin_type == 'file_guideforcourse'">
                                        <BreezeLabel for="src_object_id" value="Curso relacionado a la guía de estudio" :required="true" />
                                    </template>
                                    <template v-else-if="origin_type == 'file_forlevel'">
                                        <BreezeLabel for="src_object_id" value="Nivel escolar al que se mostrará este archivo" :required="true" />
                                    </template>
                                    
                                    <select id="src_object_id" class="mt-1 block w-full border-gray-300 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 rounded-md shadow-sm" v-model="form.src_object_id" required >
                                        <option value="0" selected="selected">Todos</option>
                                        <option v-for="field in object_target" :value="field.id">{{ field.label_object}}</option>
                                    </select>
                                </div>
                                <!-- <div class="mt-4">
                                    <BreezeLabel for="file" value="Subir archivo"/>
                                    <BreezeInput id="file" ref="file" type="file" class="mt-1 block w-full" v-model="form.originName" autocomplete="file" @change="handleFileUp" accept=".PDF, .PNG, .JPG" />
                                </div> -->
                                <div class="mt-4">
                                    <BreezeLabel for="position" value="Posición" :required="true" /><!--v-model="form.position"-->
                                    <BreezeInput id="position" ref="position" type="number" class="mt-1 block w-full" v-model="form.position" required autocomplete="position" /><!--.XLSX, -->
                                </div>
                                
                                <!--<span>{{form.file}}</span>-->
                                <br>
                                <div v-if="object"> 
                                    <embed :src="'/documents/'+object.filepath+'/'+object.filename" class="object-cover h-48">
                                    
                                </div>
                                <!--
                                <div class="mt-4">
                                    <BreezeLabel for="password" value="Password" />
                                    <BreezeInput id="password" type="password" class="mt-1 block w-full" v-model="form.password" required autocomplete="new-password" />
                                </div>

                                <div class="mt-4">
                                    <BreezeLabel for="password_confirmation" value="Confirm Password" />
                                    <BreezeInput id="password_confirmation" type="password" class="mt-1 block w-full" v-model="form.password_confirmation" required autocomplete="new-password" />
                                </div>-->

                                <div class="flex items-center justify-end mt-4">
                                    <Link :href="route('file-listado', origin_type)" class="btn btn-outline-gray"><!-- update 230412 : underline text-sm text-gray-600 hover:text-gray-900 -->
                                        Volver al listado
                                    </Link>
                                    <BaseButton
                                    v-if="deleteable"
                                    color="danger"
                                    label="Eliminar"
                                    small
                                    @click="initModal(object.id, 'eliminar')"
                                    class="ml-4"
                                    />
                                    <BreezeButton class="ml-4" :class="{ 'opacity-25': form.processing }" :disabled="form.processing">
                                        Actualizar
                                    </BreezeButton>
                                    
                                </div>
                            </form>
                        </template>
                    </div>
                </div>
            </div>
        </div>
    </BreezeAuthenticatedLayout>
</template>
